import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';

import { locale as vn } from './shared/i18n/vn';
import { locale as english } from './shared/i18n/en';

@Injectable()
export class CustomMatPaginatorIntl extends MatPaginatorIntl {
    constructor(
        private _translateService: TranslateService,
        private _fuseTranslationLoaderService: FuseTranslationLoaderService) {
        super();
        this._fuseTranslationLoaderService.loadTranslations(english, vn);
        this.getAndInitTranslations();
        this._translateService.onLangChange.subscribe(() => {
            this.getAndInitTranslations();
        });
    }

    getAndInitTranslations() {
        this.itemsPerPageLabel =  this._translateService.instant('PAGINATION.ITEM_PER_PAGE');
        this.changes.next();
    }

    getRangeLabel = (page: number, pageSize: number, length: number) => {
        if (length === 0 || pageSize === 0) {
            return `0 ${this._translateService.instant('PAGINATION.OF')} ${length}`;
        }
        length = Math.max(length, 0);
        const startIndex = page * pageSize;
        const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
        return `${startIndex + 1} - ${endIndex} ${this._translateService.instant('PAGINATION.OF')} ${length}`;
    };
}
